<div class="flex-end">
    <button mat-icon-button style="background-color: white; color: #6f0b0f;" class="small-icon-button"
        (click)="closeModal()">
        <mat-icon>close</mat-icon>
    </button>
</div>




<div class="profile-section">
        <div class="avatar-1" alt="avatar">
            <mat-icon  class="avatar" style="color: #6f0b0f;font-size: 100px;">business</mat-icon>


        </div>

    <div class="name">{{data.name}}</div>
    <div class="location">{{ data.type}}</div>
</div>

<div style="padding: 10px;">
    <div class="center mt-1">
        <!-- <div class="split-el">
            <div class="topic">Record type</div>
            <div class="sub-topic">{{ data.type }}</div>
        </div> -->

        <div class="split-el">
            <div class="topic">Modifier's Name</div>
            <div class="sub-topic">{{ data.modifiedby.fullname }}</div>
        </div>

        <div class="split-el textEnd">
            <div class="topic">Modifier's Email Address</div>
            <div class="sub-topic">{{ data.modifiedby.contactEmail }}</div>
        </div>


       

        
    </div>

    <div class="center mt-1">
        <div class="split-el ">
            <div class="topic">Modifier's Phone Number</div>
            <div class="sub-topic">{{ data.modifiedby.contactMobile}}</div>
        </div>


        <div class="split-el textEnd" > 
            <div class="topic">Modifier's Designation</div>
            <div class="sub-topic">{{ data.modifiedby.designation }}</div>
        </div>


        <!-- <div style="width: 26%;">
            <div class="topic">Organization Type</div>
            <div class="sub-topic">Private</div>
        </div>

        <div style="width: 23.5%;">
            <div class="topic">Number Of Employees</div>
            <div class="sub-topic">2500</div>
        </div> -->
    </div>


    <!-- <div class="center mt-1">
        <div class="split-el">
            <div class="topic">CAC</div>
            <div class="sub-topic">02003291281920</div>
        </div>

        <div style="width: 41%;">
            <div class="topic">TIN</div>
            <div class="sub-topic">002235475892</div>
        </div>

        <div class="split-el">

        </div>
    </div> -->

</div>
<div class="flex-el">
    <a  style = "margin-left: auto;" mat-button color="primary" (click)="viewMore()" >
        <mat-icon>visibility</mat-icon>
        View more
    </a>

</div>